import { Box, Grid, Stack, Tab, Tabs, Typography } from "@mui/material";
import { ShowBase } from "ra-core";
import { FC, useEffect, useState } from "react";
import { CreateFileCatalogTile, CreateFileAuditTile, OfflineFileSearchTile, DataManagerReportsTile } from "@/components/securefiles/entryTiles";
import SecureFilesTable from "@/components/securefiles/SecureFileUpdatesTable";
import { useDispatch } from "react-redux";
import { raiseResetBreadcrumbsProviders } from "@/actions/breadcrumbProvider";
import OwnershipTab from "@/components/securefiles/OwnershipTab";
import { useResourceRegister } from "@/utils/resourceRegister";
import { Content } from "@/components/content/Content";
import { OdResourcePageProps } from "@/types/resource";
import OwnershipPieChart, { DataPointClickHandler } from "@/components/securefiles/OwnershipPieChart";
import { ClassificationRuleAmbinetDataCotnextProvider } from "@/components/securefiles/ClassificationRuleAmbientDataProvider";
import { push } from "connected-react-router";
import { osfCatalogRes, pfsCatalogRes } from "@/components/securefiles/FileCataSearchContextProvider";
import { useOdPermissions } from "@/authProvider/useOdPermissions";
import { MANAGE_DATA_CATALOG } from "@/constants";


const SecureFileDashboard: FC<OdResourcePageProps> = () => {
  useResourceRegister({ name: 'secure-files-ownership-rules' })
  useResourceRegister({ name: 'secure-files/clients/serveredition' })

  const permissions = useOdPermissions()
  const hasDataCatalogPermit = permissions.has(MANAGE_DATA_CATALOG)
  const dispatch = useDispatch()
  const [filesTab, setFilesTab] = useState<'operations'|'ownership'>('operations');
  useEffect(() => {
    dispatch(raiseResetBreadcrumbsProviders())
  }, [dispatch])

  const enterFileCatalog = (s: string) :DataPointClickHandler => (x, { dataPoint }) => {
    if (x === 'legend') { return }
    dispatch(push('/secure-files/file-catalog', { currRes: s }))
  }

  return (
    <ShowBase resource="secure-files/dashboard" basePath="" id="-1" >
      <Content pageName="SecureFile Dashboard" resourceName="SecureFile Dashboard">
        <Grid container spacing={4} sx={{ pt: 2 }}>
          <Grid item xs={12} sm={6} md={3}>
            <CreateFileCatalogTile />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CreateFileAuditTile />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <OfflineFileSearchTile />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DataManagerReportsTile />
          </Grid>
          {/* <Grid item xs={12} sm={6} md={3}>
            <CreateFileOwnershipTile />
          </Grid> */}

          <Grid item xs={12} container spacing={4} >
            <ClassificationRuleAmbinetDataCotnextProvider>
              <Grid item xs={6}>
                <Box>
                  <Typography variant="body1" color="text.primary" mb={1}>Encrypted Files</Typography>
                  <OwnershipPieChart forPlainFiles={false} onDataPointClick={enterFileCatalog(osfCatalogRes)} />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box>
                  <Typography variant="body1" color="text.primary" mb={1}>Unencrypted Files</Typography>
                  <OwnershipPieChart forPlainFiles={true} onDataPointClick={enterFileCatalog(pfsCatalogRes)} />
                </Box>
              </Grid>
            </ClassificationRuleAmbinetDataCotnextProvider>
          </Grid>

          <Grid item xs={12}>
            <Stack direction="row" alignItems="center" sx={{ mt: 2, borderBottom: theme => `1px solid ${theme.palette.divider}` }}>
              <Typography variant="h6" color="textPrimary" mr={"15%"}>
                Files
              </Typography>
              
              {/* Tab Navigation */}
              <Tabs sx={{ '& button.MuiTab-root': { textTransform: 'unset' } }}
                value={filesTab} onChange={(_, v) => setFilesTab(v)}>
                <Tab label="Latest Operations" value="operations" data-testid="operations-tab" />
                {hasDataCatalogPermit &&
                  <Tab label="Ownership" value="ownership" data-testid="ownership-tab-btn" />}
              </Tabs>
            </Stack>

            {/* Tab Content */}
            <Box sx={{ mt: 2 }}>
              {filesTab === 'operations' ? <SecureFilesTable /> 
                : (hasDataCatalogPermit ? <OwnershipTab /> : null)}
            </Box>
          </Grid>
        </Grid>
      </Content>
    </ShowBase>
  )
}

export default SecureFileDashboard;

